var watchlistCreate = {
	confirmBtn: "Ok",
	cancelBtn: "Annulla",
	title: "Crea una nuova watchlist",
	placeholder: "Nome",
	nameInputLabel: "Nome di Watchlist",
	nameInputTip: "Max. 100 caratteri – Caratteri validi a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	validationErrors: {
		name: {
			invalidInput: "Il nome non è valido. Max. 100 caratteri – Caratteri validi a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var it = {
	watchlistCreate: watchlistCreate
};

export { it as default, watchlistCreate };
